import DocumentAssistance from '../../../document/pages/Assistance';
import {
    GET_CHANNELS_OVERVIEW_DATA,
    DELIVERY_NOTE_EXTRACT_TEXT,
    GET_ASSISTANCE_OVERVIEW_DATA,
    GET_NEXT_ASSISTANCE_RECORD,
    GET_RELATED_DOCUMENT,
    RE_UPLOAD_FILE,
    REOPEN_FOR_ASSISTANCE,
    RETRY_STEP,
    SEND_TO_LABELING,
} from '../queries.ts';
import {
    ASSISTANCE_PATH,
    ASSISTANCE_TAB_PATH,
    CHANNEL_FINISHED_PATH,
    CHANNEL_PATH,
    CHANNEL_TESTING_PATH,
    OVERVIEW_FINISHED_PATH,
    OVERVIEW_PATH,
    OVERVIEW_TESTING_PATH,
} from '../constants.ts';
import { DocumentType } from '../../../document/constants.ts';
import {
    getCustomerFieldConditionalComponents,
    getCustomerFieldGroupConditionalComponents,
} from '../../../document/components/CustomerField.tsx';
import { getAddressFieldConditionalComponents } from '../../../document/components/AddressField.tsx';
import { ArticleNumberFieldConditionalComponents } from '../../../document/components/ArticleNumberField.tsx';
import * as React from 'react';
import { extractText } from '../../../document/pages/Assistance/utils.tsx';
import { merge } from 'lodash';
import { useAssistanceContext } from '../../../document/pages/Assistance/AssistanceContext.tsx';

export const documentTypeName = 'deliveryNote';

const fieldNameToGroupTypeMap = {
    supplier: 'CustomerField',
    buyer: 'CustomerField',
    deliveryAddress: 'AddressField',
};

const DeliveryNoteAssistance = (props) => {
    const documentConfiguration = {
        documentType: DocumentType.DeliveryNote,
        documentTypeName: 'deliveryNote',
        supportsAgenticExtraction: true,
        GET_ASSISTANCE_OVERVIEW_DATA: GET_ASSISTANCE_OVERVIEW_DATA,
        GET_CHANNELS_OVERVIEW_DATA: GET_CHANNELS_OVERVIEW_DATA,
        GET_NEXT_ASSISTANCE_RECORD: GET_NEXT_ASSISTANCE_RECORD,
        GET_RELATED_DOCUMENT: GET_RELATED_DOCUMENT,
        RETRY_STEP: RETRY_STEP,
        REOPEN_FOR_ASSISTANCE: REOPEN_FOR_ASSISTANCE,
        ASSISTANCE_PATH: ASSISTANCE_PATH,
        ASSISTANCE_TAB_PATH: ASSISTANCE_TAB_PATH,
        OVERVIEW_PATH: OVERVIEW_PATH,
        OVERVIEW_FINISHED_PATH: OVERVIEW_FINISHED_PATH,
        OVERVIEW_TESTING_PATH: OVERVIEW_TESTING_PATH,
        CHANNEL_PATH: CHANNEL_PATH,
        CHANNEL_FINISHED_PATH: CHANNEL_FINISHED_PATH,
        CHANNEL_TESTING_PATH: CHANNEL_TESTING_PATH,
        RE_UPLOAD_FILE: RE_UPLOAD_FILE,
        EXTRACT_TEXT: DELIVERY_NOTE_EXTRACT_TEXT,
        SEND_TO_LABELING: SEND_TO_LABELING,
        components: {
            Field: [
                ...getCustomerFieldConditionalComponents('supplier'),
                ...getCustomerFieldConditionalComponents('buyer'),
                ...getAddressFieldConditionalComponents('delivery_address'),
                ...ArticleNumberFieldConditionalComponents,
            ],
            HeaderDataFieldGroup: [
                ...getCustomerFieldGroupConditionalComponents('supplier'),
                ...getCustomerFieldGroupConditionalComponents('buyer'),
            ],
        },
    };

    return <DocumentAssistance documentConfiguration={documentConfiguration} {...props} />;
};

export default DeliveryNoteAssistance;
